<template>
  <div class="opc-global-error__cart">
    <div class="opc-global-error__cart-upper">
      <h2>{{ $t('billing.order_summary') }}</h2>
    </div>
    <zm-skeleton :rows="10" />
  </div>
</template>

<script>
export default {
  name: 'ErrorCart',
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-global-error__cart {
  height: 100%;
  display: flex;
  flex-direction: column;

  .zm-skeleton {
    padding-top: 20px;
  }

  @include media(mobile, tablet) {
    background: #F7F7F8;
  }

  &-upper {
    padding: 64px 60px 0px;
    @include media(mobile, tablet) {
      background: #F7F7F8;
      padding: $mobile-space;
    }

    font-style: normal;
    line-height: 48px;
    display: flex;
    font-family: $happy-display;

    h2{
      font-weight: 400;
      font-size: 24px;
      @include media(mobile,tablet){
        font-size: 16px;
      }
    }
  }
}
</style>
